@if (fileName.length) {
  <div layout>
    @if (fileName.length) {
      <rt-button variant="tertiary" (click)="fileChange.emit()" margin-right-small-x>
        <rt-truncate>{{ fileName }}</rt-truncate>
      </rt-button>
    }
    @if (closable() && fileName.length) {
      <rt-icon-button variant="plain" iconName="close" shape="square" (click)="closed.emit()" />
    }
  </div>
} @else {
  <rt-pdf-viewer [assetUrl]="encodedUrl" />
}
